import { PAYMENT_DEFAULT_VALUE } from '~/data/searchFlowData';
import { useMemo } from 'react';

export const useIsMaxRangePriceBudget = (price: number) => {
  return useMemo(
    () =>
      price === PAYMENT_DEFAULT_VALUE.monthly.maxPrice ||
      price === PAYMENT_DEFAULT_VALUE.oneTime.maxPrice,
    [price],
  );
};
